import React from "react";
import SVG from "./svg";

const HomeAbout = () => {
  return (
    <div className="container-fluid" id="about">
      <section className="my-1 pt-5">
        <div className="row pt-2 align-items-center">
          <div className="col-lg-5 col-md-12 mb-2">
            <SVG></SVG>
          </div>
          <div className="col-lg-6 ml-auto col-md-12 px-0 px-lg-4 pl-md-0">
            <h3 className="mb-5 title text-center font-weight-bold">
              <strong>Build your future with us</strong>
            </h3>

            <p align="justify" className="font-weight-bolder">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nemo
              animi soluta ratione quisquam, dicta ab cupiditate iure eaque?
              Repellendus voluptatum, magni impedit delectus, beatae maxime
              temporibus maiores quibusdam.
            </p>
            <p align="justify" className="font-weight-bolder">
              Rem magnam ad perferendis iusto sint tempora ea voluptatibus iure,
              animi excepturi modi aut possimus in hic molestias repellendus
              illo ullam odit quia velit. Lorem ipsum dolor sit amet,
              consectetur adipisicing elit.
            </p>
            <p align="justify" className="font-weight-bolder">
              Incidunt eligendi mollitia labore ipsum ex fugit explicabo saepe
              error neque beatae in, expedita eveniet quae aliquam assumenda
              voluptatibus!
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomeAbout;
